import { createAction } from '@reduxjs/toolkit';

import { getPayloadCreator } from 'app-components/flux/core/actionHelpers';
import type { QcsSyncResourcesPayload } from 'app-components/flux/core/resourceStoreTypes';

import type { ShareInput, ShareProps } from './types';

const noPayloadCreator = getPayloadCreator<void, ShareProps>();
const sharePayloadCreator = getPayloadCreator<ShareInput, ShareProps>();
const sharesPayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<ShareProps>, ShareProps>();
const errorPayloadCreator = getPayloadCreator<unknown, ShareProps>();

export const getShares = createAction('GET_SHARES', noPayloadCreator);
export const getSharesSuccess = createAction('GET_SHARES_SUCCESS', sharesPayloadCreator);
export const getSharesFailure = createAction('GET_SHARES_FAILURE', errorPayloadCreator);

export const createShare = createAction('CREATE_SHARE', sharePayloadCreator);
export const createShareSuccess = createAction('CREATE_SHARE_SUCCESS', sharePayloadCreator);
export const createShareFailure = createAction('CREATE_SHARE_FAILURE', errorPayloadCreator);

export const updateShare = createAction('UPDATE_SHARE', sharePayloadCreator);
export const updateShareSuccess = createAction('UPDATE_SHARE_SUCCESS', sharePayloadCreator);
export const updateShareFailure = createAction('UPDATE_SHARE_FAILURE', errorPayloadCreator);

export const deleteShare = createAction('DELETE_SHARE', sharePayloadCreator);
export const deleteShareSuccess = createAction('DELETE_SHARE_SUCCESS', sharePayloadCreator);
export const deleteShareFailure = createAction('DELETE_SHARE_FAILURE', errorPayloadCreator);
